module.exports = __webpack_public_path__ + "assets/img/honor3.847ab9bc.png";